import React from 'react';

export const GOLD = '#fbbf24';

export const Section = ({ title, children, testId, accent = 'rgba(251, 191, 36, 0.25)' }) => (
  <section data-testid={testId} style={{ background: 'rgba(255,255,255,0.04)', border: `1px solid ${accent}`, borderRadius: '12px', padding: '1.1rem 1.25rem', marginBottom: '1rem' }}>
    {title && <h3 style={{ color: GOLD, margin: '0 0 0.75rem', fontSize: '1.1rem', fontWeight: 700 }}>{title}</h3>}
    <div style={{ color: '#e2e8f0', fontSize: '0.95rem', lineHeight: 1.65 }}>{children}</div>
  </section>
);

export const Steps = ({ items, testId }) => (
  <ol data-testid={testId} style={{ margin: 0, paddingLeft: '1.25rem', display: 'grid', gap: '0.6rem' }}>
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ol>
);

export const B = ({ children, color = GOLD }) => <strong style={{ color }}>{children}</strong>;

export const Outcome = ({ label, value, color }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', padding: '0.5rem 0.75rem', borderRadius: '8px', background: 'rgba(0,0,0,0.25)' }}>
    <span>{label}</span><strong style={{ color, whiteSpace: 'nowrap' }}>{value}</strong>
  </div>
);
